<template>
    <thead :class="[$style['mds-thead'], classObject]">
        <template v-if="nestedHeaders">
            <tr :class="$style['mds-thead__group']" v-for="(n, index) in nestedHeaders" :key="index">
                <th style="width: 30px;" v-if="multiselection" />
                <th style="width: 20px;" v-if="rowNumbers" />
                <slot :name="`mds-thead-group-${n}`" />
            </tr>
        </template>
        <tr>
            <th :class="$style['mds-thead__th-selection']" scope="col" v-if="multiselection">
                <mds-checkbox
                    :hidden-label="true"
                    :label="multiselectionLabel"
                    :value="multiselectionLabel"
                    :indeterminate="indeterminate"
                    :checked="checked"
                    :on-dark="onDark"
                    :size="size"
                    @change.native="emitHeaderSelectEvent($event)"
                />
            </th>
            <th :class="$style['mds-thead__th-numbered']" v-if="rowNumbers" />
            <slot />
        </tr>
    </thead>
</template>

<script>
    import MdsCheckbox from '@mds/checkbox';

    export default {
        name: 'MdsThead',
        components: {
            MdsCheckbox,
        },
        inject: ['parentVariation'],
        props: {
            checked: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, sets the row multiselection checkbox to checked.',
                },
            },
            hiddenHeader: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, applies styling to visible hide the thead content',
                },
            },
            indeterminate: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, sets the row multiselection checkbox to intederminate state.',
                },
            },
            multiselectionLabel: {
                type: String,
                default: 'Select or Unselect All Rows',
                docs: {
                    validation: '—',
                    description: 'Applies the value to the multiselection checkbox label.',
                },
            },
            nestedHeaders: {
                type: Number,
                docs: {
                    validation: '—',
                    description: 'Determines how many named nested header slots will be created',
                },
            },
        },
        computed: {
            multiselection() {
                return this.parentVariation && this.parentVariation.multiselection;
            },
            rowNumbers() {
                return this.parentVariation && this.parentVariation.rowNumbersCol;
            },
            onDark() {
                return this.parentVariation && this.parentVariation.onDark;
            },
            size() {
                return this.parentVariation && this.parentVariation.size;
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-thead--hidden-header']] = this.hiddenHeader;

                return obj;
            },
        },
        methods: {
            emitHeaderSelectEvent($event) {
                this.$emit('mds-thead-multiselection-changed', $event);
            },
        },
    };
</script>

<style lang="scss" module>
    @import './thead.scss';
</style>
